import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getStorageValues } from '../CommonFunctions';

function VehicleDropdown({ onChangeDropdown, required, showLabel = true, isDisabled, selectedValue }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) {
          console.warn('VehicleDropdown: API base URL missing, skipping fetch.');
          return;
        }
        const body = { UserId: getStorageValues('userId') };
        const response = await axios.post(`${baseUrl}/vehicle/getall`, body);
        if (response.status === 200 && response.data?.data) {
          const vehicleArray = response.data.data;
          const list = Array.isArray(vehicleArray) && vehicleArray.length > 0 && Array.isArray(vehicleArray[0])
            ? vehicleArray[0]
            : vehicleArray;
          if (!Array.isArray(list)) {
            console.warn('VehicleDropdown: Unexpected vehicle payload format', response.data?.data);
            return;
          }
          const mapped = list.map((v) => ({
            value: v.VehicleId?.toString(),
            label: (v.VehicleLabel || `${v.Manufacturer || ''} ${v.ModelName || ''} ${v.Variant || ''} ${v.Segment || ''} ${v.Color || ''} ${v.EngineCC || ''}`).replace(/\s+/g, ' ').trim(),
            raw: v,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load vehicles', err);
      }
    };
    fetchVehicles();
  }, [selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option, actionMeta) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option, actionMeta);
    }
  };

  return (
    <div>
      {showLabel && (
        <label className="form-label">
          Vehicle {required ? <span style={{ color: 'red' }}>*</span> : null}
        </label>
      )}
      <Select
        name="VehicleId"
        value={selectedOption}
        isClearable
        isDisabled={isDisabled}
        options={options}
        onChange={handleChange}
        placeholder="Select vehicle"
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
}

export default VehicleDropdown;
